module.exports = __webpack_public_path__ + "static/media/spielhaus.a4ed2b9c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/spielhaus.jpeg
// module id = 106
// module chunks = 0